import { Paperclip } from 'lucide-react'

// Renders a comment body with:
//  - file mentions `#[filename]` -> colored, clickable chip (opens preview)
//  - URLs -> links
const URL_REGEX = /https?:\/\/[^\s<>"']+/g
const FILE_MENTION_REGEX = /#\[([^\]]+)\]/g

function linkify(text, keyBase) {
    const parts = []
    let last = 0
    let m
    const re = new RegExp(URL_REGEX.source, 'g')
    while ((m = re.exec(text)) !== null) {
        if (m.index > last) parts.push(text.slice(last, m.index))
        const url = m[0]
        parts.push(
            <a key={`${keyBase}-u${m.index}`} href={url} target="_blank" rel="noopener noreferrer" className="linkify-link" onClick={(e) => e.stopPropagation()}>{url}</a>,
        )
        last = m.index + url.length
    }
    if (last < text.length) parts.push(text.slice(last))
    return parts
}

export default function CommentBody({ text, className, attachments = [], onPreviewFile }) {
    if (!text) return null
    const byName = new Map((attachments || []).map((a) => [a.name, a]))
    const out = []
    let last = 0
    let m
    let i = 0
    const re = new RegExp(FILE_MENTION_REGEX.source, 'g')
    while ((m = re.exec(text)) !== null) {
        if (m.index > last) out.push(...linkify(text.slice(last, m.index), `s${i}`))
        const name = m[1]
        const att = byName.get(name)
        if (att) {
            out.push(
                <button key={`f${i}`} type="button" className="comment-file-mention" title={name} onClick={() => onPreviewFile?.(att)}>
                    <Paperclip size={11} /> {name}
                </button>,
            )
        } else {
            out.push(<span key={`f${i}`} className="comment-file-mention comment-file-mention-missing">{name}</span>)
        }
        last = m.index + m[0].length
        i++
    }
    if (last < text.length) out.push(...linkify(text.slice(last), `s${i}`))
    return <span className={className}>{out}</span>
}
